import React from 'react'
import Hero from '../components/Hero'
import Team from '../components/Team'
import SignUp from '../components/ContactUs/SignUp'
import WhySaatchi from '../components/WhySaatchi'
import EmailFooter from '../components/EmailFooter'
import { Layout } from '../components/styles'
import CaseStudy from '../components/CaseStudy'
import SubMenu from '../components/SubMenu'
type Props = {
  section: string
}

const Component = ({ section }: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <Layout>
      <Hero section={section} />
      <SubMenu section={section} />
      <WhySaatchi section={section} />
      <CaseStudy section={section} />
      <Team />
      <SignUp />
      <EmailFooter />
    </Layout>
  )
}

export default Component